import React from "react";
import * as styles from "components/layout/Search/Results/Results.module.scss";

type ResultsInIndexProps = {
  indexName: string;
  total: number;
  pages: number;
  perPage: number;
} & React.PropsWithChildren;

export const ResultsInIndex = ({
  indexName,
  children,
  total,
  pages,
  perPage,
}: ResultsInIndexProps) => {
  // don't render index unless there are results in it
  if (total === 0) return null;

  const moreResultCount = total - perPage;
  const moreResultsText = `+${moreResultCount} result${moreResultCount > 1 ? "s" : ""}. Continue refining.`;

  return (
    <div className={styles.index}>
      <div className={styles.indexHeaderSticky}>
        <div className={styles.indexHeader}>
          <span className={styles.indexName}>{indexName}</span>
        </div>
      </div>

      <div className={styles.rows}>{children}</div>
      {pages > 1 && (
        <div className={styles.moreResults}>
          <div className={styles.moreResultsInner}>{moreResultsText}</div>
        </div>
      )}
    </div>
  );
};
